import dedent from './dedent';

export default {
  key: 'wordpress',
  lang: 'html',
  generate: ({ webWidgetScript }) =>
    [
      '<!-- Recommended: install a code snippets plugin such as WPCode. -->',
      '<!-- Add a new snippet, set the type to HTML and the location to site-wide footer. -->',
      '<!-- Alternative: add the code to your child theme footer.php, just before </body>. -->',
      dedent(webWidgetScript),
    ].join('\n'),
};
